import styled from 'styled-components';

export const LoadingDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem 0 5rem 0;
    img {
        max-width: 100px;
    }
`